// @ts-nocheck
import React from "react";
import style from "./ChangePlan.module.scss";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import PropTypes from "prop-types";
import { InfoBtn } from "../../common/Payment/InfoBtn";
import { SecondaryBtn } from "../../common/Payment/SecondaryBtn";
import { useTranslation, Trans } from "react-i18next";

export const ChangeTrialModalBody = ({
  client,
  trialPlanName,
  trialPlanCode,
  isLoading,
  handleTrialClose,
  setNotice,
  is_internal,
}) => {
  const { t } = useTranslation();

  const updateTrialPlan = async () => {
    await axios
      .patch(`/${client}/client_trial_log/apply_new_trial`, {
        trial_plan_code: trialPlanCode,
      })
      .then((res) => {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("is_plan_change", "true");
        window.location.href = currentUrl.toString();
      })
      .catch(({ response }) => {
        alert(response.data.message);
        return;
      });
  };

  return (
    <>
      <div className={style.applyTrialWrap}>
        <div className={style.applyTrialTitle}>{t("ChangeTrialModalBody.無料トライアル申し込み")}</div>

        <div className={style.applyTrialModalContent}>
          <div className={style.applyTrialModalItemWrap}>
            <div className={style.applyTrialModalItem}>{t("ChangeTrialModalBody.プラン")}</div>
            <div className={style.applyTrialModalValue}>
              {t("ChangeTrialModalBody.trialPlanNameプラン", { trialPlanName })}
            </div>
          </div>
          <div className={style.applyTrialModalItemWrap}>
            <div className={style.applyTrialModalItem}>{t("ChangeTrialModalBody.期間")}</div>
            <div className={style.applyTrialModalValue}>
              {t("ChangeTrialModalBody.〜YYYY年MM月DD日", { date: moment().add(14, "days").format("YYYY/MM/DD") })}
            </div>
          </div>
        </div>

        <ul className={style.applyTrialModalUl}>
          <li className={style.applyTrialModalList}>
            <Trans
              i18nKey="ChangeTrialModalBody.注意事項文"
              components={{
                a: (
                  <a
                    href={t("ChangeTrialModalBody.無料トライアルに関するご注意事項")}
                    target="_blank"
                    rel="noreferrer"
                  />
                ),
              }}
            />
          </li>
          <li className={style.applyTrialModalList}>
            {is_internal
              ? t("ChangeTrialModalBody.タスク数・ライセンス数の無料枠は適用されません。")
              : t("ChangeTrialModalBody.タスク数の無料枠は適用されません。")}
          </li>
          <li className={style.applyTrialModalList}>
            <Trans
              i18nKey="ChangeTrialModalBody.機能制限文"
              components={{
                a: (
                  <a
                    href={t("ChangeTrialModalBody.無料トライアルで対象とならない機能・サービス")}
                    target="_blank"
                    rel="noreferrer"
                  />
                ),
              }}
            />
          </li>
          <li className={style.applyTrialModalList}>{t("ChangeTrialModalBody.トライアルは1度のみ体験が可能です。")}</li>
          <li>
            <Trans
              i18nKey="ChangeTrialModalBody.トライアル終了文"
              components={{
                a: <a href={t("ChangeTrialModalBody.トライアル終了時のご注意事項")} target="_blank" rel="noreferrer" />,
              }}
            />
          </li>
          <li className={style.applyTrialModalList}>
            {is_internal
              ? t(
                  "ChangeTrialModalBody.トライアル期間中に実行されたタスク、追加したライセンスは、通常通りカウントされます。",
                )
              : t("ChangeTrialModalBody.トライアル期間中に実行されたタスクは、通常通りカウントされます。")}
          </li>
        </ul>

        <div className={style.applyTrialButtonWrap} style={{ width: "100%", justifyContent: "center" }}>
          <SecondaryBtn
            text={t("ChangeTrialModalBody.戻る")}
            disabled={false}
            className={`test-force-upgrade ${style.applyTrialButton}`}
            submit={() => {
              handleTrialClose();
            }}
            style={{ color: "#222222" }}
          />
          <InfoBtn
            text={t("ChangeTrialModalBody.確認して申し込む")}
            loading={isLoading}
            className={`test-force-upgrade ${style.applyTrialButton}`}
            submit={() => {
              updateTrialPlan();
            }}
            style={{ whiteSpace: "nowrap" }}
          />
        </div>
      </div>
    </>
  );
};

ChangeTrialModalBody.propTypes = {
  client: PropTypes.string,
  trialPlanName: PropTypes.string,
  trialPlanCode: PropTypes.string,
  isLoading: PropTypes.bool,
  handleTrialClose: PropTypes.func,
  setNotice: PropTypes.func,
  is_internal: PropTypes.bool,
};
